import { handleAPIResponse } from '@/utils/apiUtils';
import { SignupData, SendOTPResponse, VerifyOTPResponse } from '@/types/auth';

const API_BASE_URL = `${process.env.NEXT_PUBLIC_API_URL}`;

export const authApi = {
  signup: async (data: SignupData) => {
    const response = await fetch(`${API_BASE_URL}/auth/signup`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });

    return handleAPIResponse<{ message: string }>(response);
  },

  sendOTP: async (email: string): Promise<SendOTPResponse> => {
    const response = await fetch(`${API_BASE_URL}/auth/send-otp`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    });

    return handleAPIResponse<SendOTPResponse>(response);
  },

  verifyOTP: async (data: { email: string; otp: string }): Promise<VerifyOTPResponse> => {
    const response = await fetch(`${API_BASE_URL}/auth/verify-otp`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });

    return handleAPIResponse<VerifyOTPResponse>(response);
  },

  login: async (data: { email: string; otp: string }): Promise<VerifyOTPResponse> => {
    const response = await fetch(`${API_BASE_URL}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });

    return handleAPIResponse<VerifyOTPResponse>(response);
  },
};
